import React from 'react';
import Dynamic from '@base/Dynamic/Dynamic';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import { TextColors } from '@styles/index';

const Loader = () => <CircularLoader color={TextColors.BLUE} />;

const RichTextEditor = Dynamic(() => import('./QuillEditor'), {
  ssr: false,
  loading: Loader
});

RichTextEditor.displayName = 'RichTextEditor';

export default RichTextEditor;
